import { useTranslate } from '@ur-solutions/react-hooks'
import type { AbsenceDetailsNode } from './absence-details'
import { AbsenceDetailsCard } from './absence-details-card'
import { FAIcon } from '@/components'
import { format, formatFileSize } from '@/utils'

interface Props {
  absence: AbsenceDetailsNode
}

export function AbsenceFiles({ absence }: Props) {
  const translations = useTranslate({
    files: 'absence.details.files',
    download: 'absence.details.files.download',
    noFiles: 'absence.details.files.no-files',
  })

  return (
    <AbsenceDetailsCard
      type="files"
      title={translations.files}
      icon="paperclip"
    >
      {absence.files.length ? (
        <ul className="divide-y divide-stone-200">
          {absence.files.map(file => (
            <li key={file.id} className="px-5 py-4 sm:px-6">
              <div className="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
                <div className="min-w-0">
                  <p className="font-medium text-stone-900 truncate">
                    {file.fileName}
                  </p>

                  <p className="mt-1 text-xs text-stone-600">
                    {formatFileSize(file.fileSize)} · {file.uploadedBy.fullName}{' '}
                    · {format(new Date(file.createdAt), 'dd.MM.yyyy HH:mm')}
                  </p>
                </div>

                <a
                  href={file.fileUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 rounded-lg border border-stone-300 px-3 py-1.5 text-xs font-semibold text-stone-700 transition hover:bg-stone-100"
                >
                  <FAIcon icon="download" type="regular" />
                  {translations.download}
                </a>
              </div>
            </li>
          ))}
        </ul>
      ) : (
        <p className="px-5 py-5 text-sm text-stone-500 sm:px-6">
          {translations.noFiles}
        </p>
      )}
    </AbsenceDetailsCard>
  )
}
